/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-const */
import React, { useEffect, useRef, useState } from "react";

// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { RichText } from "@sitecore-jss/sitecore-jss-nextjs";
import moment from "moment";
import "moment/locale/ar-ly";
import IsRtl from "components/Shared/isRtl";

type TimelineProps = {
  SectionId: string;
  fields: TimelineSectionFields;
  showAnimation?: boolean;
  TitleFontSize: string;
  DescriptionFontSize: string;
  locale: string;
};

function TimelineSection1(props: TimelineProps) {
  const [currentStepColor] = useState("#1B8354");
  const [currentStepTitleColor] = useState("#1F2A37");
  const [otherStepsColor] = useState("#D2D6DB");
  const [otherStepsTitleColor] = useState("#6C737F");
  let [Steps, setSteps] = useState<StepObject[]>([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [hoveredStep, setHoveredStep] = useState(0);
  const scrollContainerRef = useRef<any>(null);

  const [canScroll, setCanScroll] = useState(false);

  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  const [isLargeScreen, setIsLargeScreen] = useState(true);

  useEffect(() => {
    let largeScreenMinLimit = 1024;
    if (window.innerWidth >= largeScreenMinLimit) setIsLargeScreen(true);
    else setIsLargeScreen(false);
  }, [props]);

  // Function to check if scrolling is needed
  const checkScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollWidth, clientWidth, scrollLeft } = scrollContainerRef.current;
      setCanScroll(scrollWidth >= clientWidth);
      if (props?.locale == "en") {
        setAtStart(scrollLeft === 0);
        setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1); // -1 for precision
      } else {
        setAtStart(scrollLeft === 0);
        setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1); // -1 for precision
      }
    }
  };

  // Function to scroll left or right
  const scroll = (direction: string) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 200;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  // Check scrollability on initial render
  useEffect(() => {
    setTimeout(() => {
      checkScroll();
    }, 1000);
  }, []);

  // Check scrollability on mount and resize
  useEffect(() => {
    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, []);

  // Update scroll position state when user scrolls
  useEffect(() => {
    if (scrollContainerRef?.current) {
      scrollContainerRef?.current?.addEventListener("scroll", checkScroll);
      return () => scrollContainerRef?.current?.removeEventListener("scroll", checkScroll);
    }
    return scrollContainerRef?.current;
  }, []);

  // Generic date formatter that handles multiple languages using moment
  const formatDate = (dateString: string, locale: string) => {
    if (!dateString) return "";
    
    const date = moment(dateString);
    
    // Check if date is valid
    if (!date.isValid()) return "";

    // Set locale based on language
    let momentLocale = locale || "en";
    if (locale === "ar") {
      momentLocale = "ar-ly"; // Arabic locale used in the codebase
    }

    // Format based on language
    // English: "DD MMM" (no year), Arabic/Chinese/Korean: "D MMM YYYY" (with year)
    const format ="D MMM YYYY";
    
    return date.locale(momentLocale).format(format);
  };

  useEffect(() => {
    if (props?.fields?.TimelineSteps?.length) {
      let temp: StepObject[];
      const length = props?.fields?.TimelineSteps?.length; // Desired length of the array
      const emptyObject = {
        displayName: "",
        fields: {
          Title: {
            value: "",
          },
          Description: {
            value: "",
          },
          StartDate: {
            value: "",
          },
          EndDate: {
            value: "",
          },
        },
      }; // Object with empty values

      temp = Array.from({ length }, () => ({ ...emptyObject }));
      props?.fields?.TimelineSteps?.map((item: StepObject, index: number) => {
        temp[index] = {
          displayName: item?.displayName,
          fields: {
            Title: {
              value: item?.fields?.Title?.value,
            },
            Description: {
              value: item?.fields?.Description?.value,
            },
            StartDate: {
              value: item?.fields?.StartDate?.value,
            },
            EndDate: {
              value: item?.fields?.EndDate?.value,
            },
          },
        };
      });

      temp.map((item: StepObject, index: number) => {
        item.fields.EndDate.value === "0001-01-01T00:00:00Z"
          ? (temp[index].fields.EndDate.value = "")
          : null;
        item.fields.StartDate.value === "0001-01-01T00:00:00Z"
          ? (temp[index].fields.StartDate.value = "")
          : null;
      });

      Steps = [...temp];
      setSteps([...Steps]);
      let found = false;
      Steps.map((step: StepObject, index: number) => {
        let stepStartDate = new Date(step?.fields?.StartDate?.value);
        let stepEndDate = new Date(step?.fields?.EndDate?.value);
        if (
          (stepStartDate.getTime() > new Date(Date.now() - 24 * 60 * 60 * 1000).getTime() ||
            stepEndDate.getTime() > new Date(Date.now() - 24 * 60 * 60 * 1000).getTime()) &&
          !found
        ) {
          setCurrentStep(index);
          setHoveredStep(index);
          found = true;
        }
      });
    }
  }, []);

  // useEffect(() => {
  //   if (props?.showAnimation) {
  //     gsap.set(".animate-top", {
  //       opacity: 0,
  //       y: 100,
  //     });
  //     ScrollTrigger.batch(".animate-top", {
  //       onEnter: (batch) =>
  //         gsap.to(batch, {
  //           opacity: 1,
  //           y: 0,
  //           stagger: { each: 0.3 },
  //           overwrite: true,
  //           scrollTrigger: {
  //             trigger: batch,
  //             start: "top 85%",
  //             end: "bottom 20%",
  //             once: true,
  //             invalidateOnRefresh: true,
  //           },
  //         }),
  //       onEnterBack: (batch) => gsap.to(batch, { opacity: 1, y: 0, stagger: 0.2, overwrite: true }),
  //     });
  //   }
  // }, []);

  return (
    <div id={props?.SectionId} className="w-full relative py-10">
      <div className=" relative">
        <div className="animate-top-dga  responsive relative z-10 mb-5">
          <div className="flex flex-col gap-5">
            <h2 className={`animate-top-dga text-[#161616] font-bold  text-[30px]  `}>
              {props?.fields?.Title?.value}
            </h2>
            <RichText
              className={` animate-top-dga lg:text-[18px] !font-normal md:text-[16px] text-[12px] text-[#1F2A37]`}
              field={props?.fields?.Description}
            />
          </div>
        </div>
        {/* -------------------------------------------Mobile View---------------------------------------------- */}
        {!isLargeScreen && Steps?.length ? (
          <div className="animate-top-dga  relative flex flex-col gap-5 my-6  responsive">
            {Steps?.length &&
              Steps?.map((item: StepObject, index: number) => (
                <div
                  onClick={() => {
                    index === hoveredStep ? setHoveredStep(-1) : setHoveredStep(index);
                  }}
                  className="flex relative"
                  key={index}
                >
                  <div
                    className={`flex items-center justify-center w-[40px] h-[40px] rounded-full relative z-10   border-[2px] font-bold`}
                    style={{
                      color: index == currentStep ? currentStepColor : otherStepsColor,
                      borderColor: index == currentStep ? currentStepColor : otherStepsColor,
                      background: "white",
                    }}
                  >
                    <span
                      style={{ color: index == currentStep ? currentStepColor : otherStepsColor }}
                    >
                      {index + 1}
                    </span>
                  </div>
                  {index !== Steps?.length - 1 && (
                    <div
                      className={`absolute h-full w-[1px]  bg-[#0F2837] ${
                        IsRtl() ? "right-[19px]" : "left-[19px]"
                      } top-8 z-0`}
                      style={{
                        background: index == currentStep ? currentStepColor : otherStepsColor,
                      }}
                    />
                  )}
                  <div
                    className={`flex flex-col  ${
                      props?.locale == "en" ? "ml-10" : "mr-10"
                    } w-[72%] md:w-[90%]`}
                  >
                    <div
                      className="mb-2 text-[16px]    max-w-[300px] whitespace-normal transform duration-200 transition-all ease-in-out"
                      style={{
                        color: index == currentStep ? currentStepTitleColor : otherStepsTitleColor,
                        fontWeight: index === hoveredStep ? "500" : "normal",
                      }}
                    >
                      {item?.fields?.Title?.value}
                    </div>
                    <div
                      className="date text-[14px] font-thin transform duration-200 transition-all ease-in-out !ltr"
                      style={{
                        color:
                          index == currentStep ? currentStepTitleColor : otherStepsTitleColor,
                      }}
                    >
                      {(item?.fields?.StartDate?.value
                        ? formatDate(item?.fields?.StartDate?.value, props?.locale || "en")
                        : "  ") +
                        (item?.fields?.EndDate?.value
                          ? " - " + formatDate(item?.fields?.EndDate?.value, props?.locale || "en")
                          : "  ")}
                    </div>
                    <div
                      className={`my-4 !text-[14px] lg:max-w-[100vw] whitespace-normal transform duration-200 transition-all ease-in-out `}
                      style={{
                        color:
                          hoveredStep == currentStep ? currentStepTitleColor : otherStepsTitleColor,
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                        hyphens: "auto",
                        height: index === hoveredStep ? "fit-content" : "0px", // Adjust height based on content
                        opacity: index === hoveredStep ? 1 : 0, // Fade in/out effect
                        transform: index === hoveredStep ? "translateY(0)" : "translateY(-15px)", // Slide from top
                        transition:
                          "max-height 0.5s ease-in, opacity 0.4s ease-in, color 0.4s ease-in,height 0.4s ease-in,transform 0.4s ease-in",
                      }}
                    >
                      <RichText field={item?.fields?.Description} />
                    </div>
                  </div>
                </div>
              ))}
          </div>
        ) : null}
        {/* --------------------------------------------------------------------------------------------------- */}
        {/* -------------------------------------------Desktop View ------------------------------------------- */}

        {isLargeScreen && props?.fields?.TimelineSteps?.length ? (
          <div className="animate-top-dga  responsive overflow-visible scrollbar-hide ">
            <div
              ref={scrollContainerRef}
              className="relative flex flex-row   overflow-x-auto scrollbar-hide "
              style={{ scrollBehavior: "smooth", whiteSpace: "nowrap" }}
            >
              {Steps?.length &&
                Steps?.map((item: StepObject, index: number) => (
                  <div
                    onMouseEnter={() => setHoveredStep(index)}
                    onMouseLeave={() => {
                      setHoveredStep(currentStep);
                    }}
                    className="flex relative !flex-1 !cursor-pointer min-w-[235px]"
                    key={index}
                  >
                    <div
                      className="flex items-center justify-center w-[40px] h-[40px] rounded-full relative z-10  border-[2px]  font-bold"
                      style={{
                        color: index == currentStep ? currentStepColor : otherStepsColor,
                        borderColor: index == currentStep ? currentStepColor : otherStepsColor,
                        background: "white",
                      }}
                    >
                      <span
                        style={{ color: index == currentStep ? currentStepColor : otherStepsColor }}
                      >
                        {index + 1}
                      </span>
                    </div>
                    {index !== Steps?.length - 1 && (
                      <div
                        className={`absolute w-full h-[1px]  ${
                          IsRtl() ? "right-[19px]" : "left-[19px]"
                        } top-5 z-0`}
                        style={{
                          background: index == currentStep ? currentStepColor : otherStepsColor,
                        }}
                      />
                    )}
                    <div
                      className={`flex flex-col  ${
                        props?.locale == "en" ? "-ml-7" : "-mr-7"
                      } mt-16 `}
                    >
                      <div
                        className="mb-2 text-[16px]   max-w-[217px] whitespace-normal transform duration-200 transition-all ease-in-out"
                        style={{
                          color:
                            index == currentStep ? currentStepTitleColor : otherStepsTitleColor,
                          transform: index === hoveredStep ? "scale(1.04)" : "none",
                          fontWeight: index === hoveredStep ? "500" : "normal",
                          //   marginInlineStart: index === hoveredStep ? "10px" : "0",
                        }}
                      >
                        {item?.fields?.Title?.value}
                      </div>
                      <div
                        className="date text-[14px] font-thin transform duration-200 transition-all ease-in-out !ltr"
                        style={{
                          color:
                            index == currentStep ? currentStepTitleColor : otherStepsTitleColor,
                          transform: index === hoveredStep ? "scale(1.04)" : "none",
                        }}
                      >
                        {(item?.fields?.StartDate?.value
                          ? formatDate(item?.fields?.StartDate?.value, props?.locale || "en")
                          : "    ") +
                          (item?.fields?.EndDate?.value
                            ? " - " + formatDate(item?.fields?.EndDate?.value, props?.locale || "en")
                            : "  ")}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div
              className={`my-10  border-red-300 lg:max-w-[80vw] whitespace-normal `}
              style={{
                color: hoveredStep == currentStep ? currentStepTitleColor : otherStepsTitleColor,
                wordWrap: "break-word",
                overflowWrap: "break-word",
                hyphens: "auto",
              }}
            >
              <RichText field={props?.fields?.TimelineSteps[hoveredStep]?.fields?.Description} />
            </div>
            {atEnd && atStart ? null : (
              <div
                dir="ltr"
                className={` w-fit ${
                  IsRtl() ? "mr-auto" : "ml-auto"
                } flex flex-row gap-4 border-red-500`}
              >
                <button className={` w-fit`} onClick={() => scroll("left")}>
                  {atStart}
                  {canScroll &&
                  ((props?.locale === "en" && !atStart) || (!atEnd && props?.locale == "ar")) ? (
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                      <rect width="48" height="48" rx="24" fill="#1B8354" />
                      <path
                        d="M26.9998 32.6695C26.8098 32.6695 26.6198 32.5995 26.4698 32.4495L19.9498 25.9295C18.8898 24.8695 18.8898 23.1295 19.9498 22.0695L26.4698 15.5495C26.7598 15.2595 27.2398 15.2595 27.5298 15.5495C27.8198 15.8395 27.8198 16.3195 27.5298 16.6095L21.0098 23.1295C20.5298 23.6095 20.5298 24.3895 21.0098 24.8695L27.5298 31.3895C27.8198 31.6795 27.8198 32.1595 27.5298 32.4495C27.3798 32.5895 27.1898 32.6695 26.9998 32.6695Z"
                        fill="#ffffff"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                      <rect width="48" height="48" rx="24" fill="#F9FAFB" />
                      <path
                        d="M26.9998 32.6695C26.8098 32.6695 26.6198 32.5995 26.4698 32.4495L19.9498 25.9295C18.8898 24.8695 18.8898 23.1295 19.9498 22.0695L26.4698 15.5495C26.7598 15.2595 27.2398 15.2595 27.5298 15.5495C27.8198 15.8395 27.8198 16.3195 27.5298 16.6095L21.0098 23.1295C20.5298 23.6095 20.5298 24.3895 21.0098 24.8695L27.5298 31.3895C27.8198 31.6795 27.8198 32.1595 27.5298 32.4495C27.3798 32.5895 27.1898 32.6695 26.9998 32.6695Z"
                        fill="black"
                      />
                    </svg>
                  )}
                </button>

                <button className={` w-fit`} onClick={() => scroll("right")}>
                  {atEnd}
                  {canScroll &&
                  ((props?.locale === "en" && !atEnd) || (props?.locale == "ar" && !atStart)) ? (
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                      <rect width="48" height="48" rx="24" fill="#1B8354" />
                      <path
                        d="M20.9101 32.6695C20.7201 32.6695 20.5301 32.5995 20.3801 32.4495C20.0901 32.1595 20.0901 31.6795 20.3801 31.3895L26.9001 24.8695C27.3801 24.3895 27.3801 23.6095 26.9001 23.1295L20.3801 16.6095C20.0901 16.3195 20.0901 15.8395 20.3801 15.5495C20.6701 15.2595 21.1501 15.2595 21.4401 15.5495L27.9601 22.0695C28.4701 22.5795 28.7601 23.2695 28.7601 23.9995C28.7601 24.7295 28.4801 25.4195 27.9601 25.9295L21.4401 32.4495C21.2901 32.5895 21.1001 32.6695 20.9101 32.6695Z"
                        fill="white"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                      <rect width="48" height="48" rx="24" fill="#F9FAFB" />
                      <path
                        d="M20.9101 32.6695C20.7201 32.6695 20.5301 32.5995 20.3801 32.4495C20.0901 32.1595 20.0901 31.6795 20.3801 31.3895L26.9001 24.8695C27.3801 24.3895 27.3801 23.6095 26.9001 23.1295L20.3801 16.6095C20.0901 16.3195 20.0901 15.8395 20.3801 15.5495C20.6701 15.2595 21.1501 15.2595 21.4401 15.5495L27.9601 22.0695C28.4701 22.5795 28.7601 23.2695 28.7601 23.9995C28.7601 24.7295 28.4801 25.4195 27.9601 25.9295L21.4401 32.4495C21.2901 32.5895 21.1001 32.6695 20.9101 32.6695Z"
                        fill="black"
                      />
                    </svg>
                  )}
                </button>
              </div>
            )}
          </div>
        ) : null}
        {/* -------------------------------------------------------------------------------------------------- */}
      </div>
    </div>
  );
}

export default TimelineSection1;

type StepObject = {
  displayName: string;
  fields: {
    Title: {
      value: string;
    };
    Description: {
      value: string;
    };
    StartDate: {
      value: string;
    };
    EndDate: {
      value: string;
    };
  };
};

export type TimelineSectionCo = {
  displayName: "Timeline";
  fields: TimelineSectionFields;
};

export type TimelineSectionFields = {
  TimelineSteps: {
    displayName: string;
    fields: {
      Title: {
        value: string;
      };
      Description: {
        value: string;
      };
      StartDate: {
        value: string;
      };
      EndDate: {
        value: string;
      };
    };
  }[];

  ScrollToText: {
    value: string;
  };
  Title: {
    value: string;
  };
  Description: {
    value: string;
  };
  isScrollAllowed: {
    value: boolean;
  };
  SectionTemplate: {
    displayName: string;
    fields: {
      Title: {
        value: "Timeline" | string;
      };
    };
  };
};
